import React, { useState } from "react";

export const BulkProductForm = ({ categories, onSave, onCancel }) => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [productForms, setProductForms] = useState([]);
  const [step, setStep] = useState(1);

  const handleCategorySelect = () => {
    if (!selectedCategory) {
      alert("Veuillez sélectionner une catégorie");
      return;
    }
    setStep(2);
  };

  const handleImagesUpload = (e) => {
    const files = Array.from(e.target.files).slice(0, 100);
    const forms = files.map((file, index) => ({
      id: `bulk-${Date.now()}-${index}`,
      image: file,
      imagePreview: URL.createObjectURL(file),
      title: "",
      description: "",
      price: "",
      categoryId: selectedCategory,
    }));
    setProductForms(forms);
    setStep(3);
  };

  const updateProductForm = (id, field, value) => {
    setProductForms((prev) =>
      prev.map((form) => (form.id === id ? { ...form, [field]: value } : form))
    );
  };

  const removeProduct = (id) => {
    setProductForms((prev) => prev.filter((form) => form.id !== id));
  };

  const handleSubmit = () => {
    const incomplete = productForms.filter(
      (p) => !p.title || !p.description || !p.price
    );
    if (incomplete.length > 0) {
      alert(`${incomplete.length} produit(s) ont des champs vides`);
      return;
    }

    const productsData = productForms.map((form) => {
      const formData = new FormData();
      formData.append("title", form.title);
      formData.append("description", form.description);
      formData.append("price", form.price);
      formData.append("categoryId", form.categoryId);
      formData.append("image", form.image);
      return formData;
    });

    onSave(productsData);
  };

  return (
    <div
      className="admin-form"
      style={{ marginBottom: "30px", border: "2px solid #28a745" }}
    >
      <h3>Ajout en masse de produits</h3>

      {step === 1 && (
        <div>
          <div className="form-group">
            <label>
              1. Sélectionnez d'abord la catégorie pour tous les produits
            </label>
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              style={{ width: "100%", padding: "10px", fontSize: "16px" }}
            >
              <option value="">Choisir une catégorie</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="btn-save"
              onClick={handleCategorySelect}
            >
              Suivant
            </button>
            <button type="button" className="btn-cancel" onClick={onCancel}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div>
          <div className="form-group">
            <label>2. Sélectionnez jusqu'à 100 images</label>
            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImagesUpload}
              style={{ width: "100%", padding: "10px", fontSize: "16px" }}
            />
            <p style={{ color: "#666", marginTop: "10px" }}>
              Catégorie sélectionnée:{" "}
              <strong>
                {categories.find((c) => c.id === selectedCategory)?.name}
              </strong>
            </p>
          </div>
          <div className="form-actions">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => setStep(1)}
            >
              Retour
            </button>
            <button type="button" className="btn-cancel" onClick={onCancel}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div>
          <p
            style={{
              marginBottom: "20px",
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            3. Remplissez les informations pour chaque produit (
            {productForms.length} produit{productForms.length > 1 ? "s" : ""})
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            {productForms.map((form, index) => (
              <div
                key={form.id}
                style={{
                  border: "1px solid #ddd",
                  padding: "15px",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <div style={{ position: "relative" }}>
                  <button
                    type="button"
                    onClick={() => removeProduct(form.id)}
                    style={{
                      position: "absolute",
                      top: "-10px",
                      right: "-10px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                      fontSize: "18px",
                      lineHeight: "1",
                    }}
                  >
                    ×
                  </button>
                  <img
                    src={form.imagePreview}
                    alt={`Produit ${index + 1}`}
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "cover",
                      borderRadius: "4px",
                      marginBottom: "10px",
                    }}
                  />
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    Titre
                  </label>
                  <input
                    type="text"
                    value={form.title}
                    onChange={(e) =>
                      updateProductForm(form.id, "title", e.target.value)
                    }
                    placeholder="Nom du produit"
                    style={{ width: "100%", padding: "8px", fontSize: "14px" }}
                  />
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    Prix (€)
                  </label>
                  <input
                    type="number"
                    value={form.price}
                    onChange={(e) =>
                      updateProductForm(form.id, "price", e.target.value)
                    }
                    placeholder="Prix"
                    style={{ width: "100%", padding: "8px", fontSize: "14px" }}
                  />
                </div>

                <div style={{ marginBottom: "10px" }}>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "12px",
                    }}
                  >
                    Description
                  </label>
                  <textarea
                    value={form.description}
                    onChange={(e) =>
                      updateProductForm(form.id, "description", e.target.value)
                    }
                    placeholder="Description du produit"
                    rows="3"
                    style={{
                      width: "100%",
                      padding: "8px",
                      fontSize: "14px",
                      resize: "vertical",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="form-actions">
            <button type="button" className="btn-save" onClick={handleSubmit}>
              Enregistrer tous les produits ({productForms.length})
            </button>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => setStep(2)}
            >
              Retour
            </button>
            <button type="button" className="btn-cancel" onClick={onCancel}>
              Annuler
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
